import { Component, OnInit, TemplateRef, Inject, Input, Output, ViewEncapsulation, ViewChild  } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import { formatDate } from '@angular/common';


import { GestockService } from '../services/gestock.service';


@Component({
  selector: 'app-expense-dialog',
  templateUrl: './expense-dialog.component.html',
  styleUrls: ['./expense-dialog.component.css']
})
export class ExpenseDialogComponent   implements OnInit {

  expense = { description: '', category: '', amount: 0, datedeb: new Date(), datefin: new Date() };

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;

  samacaabiyoonwii : any ;

  retourClientWS : any ;

  alltypedepenses = [];


  allPoints : any ;


  choosedPoint : any ;
  choosenCategDep : any ;
  description: any ; 
  montant: any ;
  datedeb: any ; 
  datefin: any ;


  etatreq = "" ;
  selectBoutique = "" ;

  constructor(public dialogRef: MatDialogRef<ExpenseDialogComponent>,
			  	private configServer: GestockService, 
			  		@Inject(MAT_DIALOG_DATA) public data: any,
			                   public dialog: MatDialog ,
			                   private _adapter: DateAdapter<any>,
			                   @Inject(MAT_DATE_LOCALE) private _locale: string) {

  	this._locale = 'fr';
  	this._adapter.setLocale(this._locale);

  	this.alltypedepenses = data.allDepTyp;  
    this.selectBoutique = data.shop ;	
  }


  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.getAllPointsEtDepots();
  }

  saisieconforme(formNumero){
    if(formNumero==1){
      return (this.choosedPoint!=undefined && this.choosenCategDep!=undefined && 
                  this.description!=undefined && 
                  this.montant!=undefined && this.datedeb!=undefined &&
                  this.datefin!=undefined)
    }
    return false ;
  }



  save() {
    console.log(this.choosedPoint, this.choosenCategDep, 
                  this.description,this.montant, 
                  this.datedeb,this.datefin) ;
    this.registerDepense() ;
  }

  registerDepense() {
      this.openSpinnerDialog();
      let pointConcerne = JSON.stringify(this.choosedPoint) ;
      let categConcernee = JSON.stringify(this.choosenCategDep) ;

      let debPeriode = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');;
      let finPeriode = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');;

      this.configServer.addDepense(this.samacaabiyoonwii, this.description, pointConcerne, categConcernee,
               this.montant, debPeriode, finPeriode).then( (retourbi) => {

        this.closeSpinnerDialog() ;
        console.log(retourbi) ;
        this.retourClientWS = retourbi ;
        var statutreq = this.retourClientWS.statutreq;
        if(statutreq==1){
          this.etatreq='successful' ;
          console.log("Done") ;
        }
        else{
          this.etatreq='failed' ;
          console.log("Failed") ;
        }    
      }) ;  
  }


  getAllPointsEtDepots(){
    this.configServer.getAllPointsEtDepots(this.samacaabiyoonwii,  this.selectBoutique).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.allPoints = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  onLieuxStructChange(event){
  	this.choosedPoint = this.allPoints[event.value] ;  	
  }
  

  oncategChange(event){
  	this.choosenCategDep = this.alltypedepenses[event.value] ;
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }

  close(){
    this.dialogRef.close();    
  }



}